import { useState } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { thinkingMarkdownComponents } from 'components/chat-components/AgentMessage.markdown'
import styles from 'components/chat-components/AgentMessage.module.css'

import type { ThinkingContent } from 'components/chat-components/AgentMessage.types'
import type { ReactElement, SyntheticEvent } from 'react'

type ThinkingRendererProperties = {
  content: ThinkingContent
  isThinkingOpen?: boolean
}

export const ThinkingRenderer = ({ content, isThinkingOpen }: ThinkingRendererProperties): ReactElement => {
  /* --- Section 2: Local State --- */
  const [userOverride, setUserOverride] = useState<boolean | undefined>(undefined)

  /* --- Section 3: Derived Values --- */
  const isOpen = userOverride ?? isThinkingOpen ?? false

  /* --- Section 4: Event Handlers --- */
  const handleToggle = (event: SyntheticEvent<HTMLDetailsElement>): void => {
    setUserOverride(event.currentTarget.open)
  }

  /* --- Section 6: Render --- */
  return (
    <details className={styles.contentThinking} open={isOpen} onToggle={handleToggle}>
      <summary className={styles.thinkingSummary}>Thinking</summary>
      <div className={styles.thinkingText}>
        <ReactMarkdown remarkPlugins={[remarkGfm]} components={thinkingMarkdownComponents}>
          {content.thought}
        </ReactMarkdown>
      </div>
    </details>
  )
}
